'use client'

import i18n from '@/lib/i18n'
import { I18nextProvider } from 'react-i18next'
import { AuthProvider } from '@/context/AuthContext'
import { Toaster } from "@/components/ui/sonner"
import { ThemeProvider } from "@/components/theme-provider"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider defaultTheme="system" storageKey="flightdeck-theme">
        <AuthProvider>
          {children}
        </AuthProvider>
        <Toaster richColors />
      </ThemeProvider>
    </I18nextProvider>
  )
}
